<template>
  <div class="customer-contract-edit-container">
    <!-- 左侧蓝色标记和标题 -->
    <div class="page-header">
      <div class="blue-bar"></div>
      <h2 class="page-title">{{ isEdit ? '编辑销售合同' : '新增销售合同' }}</h2>
    </div>
    
    <!-- 表单区域 -->
    <el-form :model="contractForm" :rules="rules" ref="contractForm" label-width="0" class="contract-form">
      <div class="form-section">
        <div class="form-row">
          <div class="form-item">
            <label class="required-label">合同名称</label>
              <el-input v-model="contractForm.contract_name" placeholder="请输入"></el-input>
              </div>
          <div class="form-item smaller">
            <label class="required-label">是否计息</label>
            <div class="radio-group">
              <div class="radio-option bordered-option">
                <el-radio v-model="contractForm.is_interest" label="是">是</el-radio>
              </div>
              <div class="radio-option bordered-option">
                <el-radio v-model="contractForm.is_interest" label="否">否</el-radio>
              </div>
            </div>
          </div>
          <div class="form-item">
            <label class="required-label">结算方式</label>
            <div class="radio-group">
              <div class="radio-option bordered-option">
                <el-radio v-model="contractForm.settlement_method" label="每月20日结算">每月20日结算</el-radio>
              </div>
              <div class="radio-option bordered-option">
                <el-radio v-model="contractForm.settlement_method" label="按结算金额全额开具发票">按结算金额全额开具发票</el-radio>
              </div>
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item smaller">
            <label class="required-label">计价方式</label>
            <el-select v-model="contractForm.pricing_method" placeholder="固定价">
                <el-option label="固定价" value="fixed"></el-option>
                <el-option label="变动价" value="float"></el-option>
              </el-select>
          </div>
          <div class="form-item wide">
            <label class="required-label">付款方式</label>
            <div class="payment-wrapper">
              <div class="payment-input-group">
                <div class="payment-prefix">每</div>
                <el-input v-model="contractForm.payment_days" placeholder="请输入天数" class="day-input"></el-input>
                <span class="label-text">天</span>
                <span class="payment-text">结算金额, 次月最低支付70%</span>
              </div>
              
              <div class="payment-input-group payment-second-row">
                <div class="payment-prefix" style="visibility: hidden;">每</div>
                <el-input v-model="contractForm.payment_days_second" placeholder="请输入天数" class="day-input"></el-input>
                <span class="label-text">天</span>
                <span class="payment-text">结算金额付至100%</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item wide">
            <label class="required-label">选择客户方名称</label>
            <el-select 
              v-model="contractForm.customer_ids"
              multiple
              filterable
              placeholder="请选择客户"
              @change="handleCustomerChange"
              class="customer-select"
            >
              <!-- 显示客户名称选项 -->
              <el-option
                v-for="customer in customerOptions"
                :key="`customer_${customer.id}`"
                :label="customer.unit_name"
                :value="customer.id"
              >
                <span class="customer-option">
                  <span class="customer-name">{{ customer.unit_name }}</span>
                  <span class="customer-info" v-if="customer.contactPerson">
                    ({{ customer.contactPerson }})
                  </span>
                </span>
              </el-option>
            </el-select>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item wide">
            <label class="required-label">计息条件</label>
            <el-input v-model="contractForm.interest_condition" placeholder="请输入免息期"></el-input>
          </div>
        </div>
      
        <div class="form-row">
          <div class="form-item wide">
            <div class="interest-rate-wrapper">
              <!-- 固定利率 -->
              <div class="interest-rate-group">
                <div class="rate-radio-container">
                  <el-radio v-model="contractForm.interest_type" label="固定利率" class="rate-radio" @change="handleInterestTypeChange">固定利率</el-radio>
                </div>
                <div class="rate-inputs-container">
                  <el-input 
                    v-model="contractForm.fixed_interest_rate" 
                    placeholder="请输入固定利率" 
                    class="rate-input"
                    :disabled="contractForm.interest_type !== '固定利率'"
                  ></el-input>
                  <span class="label-text">%</span>
                </div>
              </div>
              
              <!-- 变动利率标题行 -->
              <div class="interest-rate-group">
                <div class="rate-radio-container">
                  <el-radio v-model="contractForm.interest_type" label="变动利率" class="rate-radio" @change="handleInterestTypeChange">变动利率</el-radio>
                </div>
                <div class="rate-inputs-container">
                  <el-button 
                    v-if="contractForm.interest_type === '变动利率'"
                    type="primary" 
                    class="add-btn" 
                    icon="el-icon-plus"
                    @click="addVariableRate"
                  >新增变动利率</el-button>
                </div>
              </div>
              
              <!-- 变动利率列表 -->
              <template v-if="contractForm.interest_type === '变动利率'">
                <div 
                  v-for="(rate, index) in variableRates" 
                  :key="index"
                  class="interest-rate-group variable-rate-row"
                >
                  <div class="rate-radio-container"></div>
                  <div class="rate-inputs-container">
                    <el-input 
                      v-model="rate.days" 
                      placeholder="请输入天数" 
                      class="day-input"
                    ></el-input>
                    <span class="label-text">天</span>
                    <el-input 
                      v-model="rate.rate" 
                      placeholder="请输入变动利率" 
                      class="rate-input percent"
                    ></el-input>
                    <span class="label-text">%</span>
                    <el-button 
                      type="danger" 
                      class="variable-rate-delete-btn" 
                      icon="el-icon-delete"
                      @click="removeVariableRate(index)"
                    >删除</el-button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      
      <div class="table-section">
        <div class="table-header">
          <el-upload
            class="excel-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="beforeExcelUpload"
            :http-request="handleExcelUpload"
          >
            <el-button v-permission="'contracts:customer-contract-edit:import'" type="primary" class="import-btn" icon="el-icon-download">导入清单</el-button>
          </el-upload>
        </div>
        
        <el-table
          :data="contractForm.products"
          border
          style="width: 100%; margin-top: 15px"
        >
          <el-table-column label="分类" prop="category" width="80"></el-table-column>
          <el-table-column label="序号" prop="seq_no" width="60"></el-table-column>
          <el-table-column label="材料名称" prop="material_name" width="120"></el-table-column>
          <el-table-column label="规格型号" prop="spec_model" width="130"></el-table-column>
          <el-table-column label="单位" prop="unit" width="60"></el-table-column>
          <el-table-column label="数量" prop="quantity" width="60"></el-table-column>
          <el-table-column label="单价金额（元）" prop="unit_price" width="120">
            <template slot-scope="scope">
              {{ formatUnitPrice(scope.row.unit_price) }}
            </template>
          </el-table-column>
          <el-table-column label="税率" prop="tax_rate" width="80">
            <template slot-scope="scope">
              {{ formatTaxRate(scope.row.tax_rate) }}
            </template>
          </el-table-column>
          <el-table-column label="含税单价（元）" prop="tax_price" width="120"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                v-permission="'contracts:customer-contract-edit:delete-item'"
                type="text"
                size="small"
                @click="removeProduct(scope.$index)"
                class="delete-btn"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="contractForm.products.length"
            :current-page.sync="pagination.currentPage"
            :page-size="pagination.pageSize"
          ></el-pagination>
        </div>
      </div>
      
      <div class="form-actions">
        <el-button v-permission="'contracts:customer-contract-edit:create'" type="primary" @click="submitForm('contractForm')">保存</el-button>
        <el-button type="success" @click="previewContract" v-if="contractId">预览合同</el-button>
        <el-button @click="goBack">返回</el-button>
      </div>
    </el-form>
    
    <!-- 导入清单对话框 -->
    <el-dialog v-dialog-drag title="导入清单" :visible.sync="importDialogVisible" width="500px" :close-on-click-modal="false">
      <el-upload
        class="upload-area"
        action="#"
        :file-list="importFileList"
        :before-upload="beforeImportUpload"
        :http-request="handleImportUpload"
      >
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件，且不超过10MB</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmImport">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { getContractById, saveContract } from '@/api/modules/contracts.js';
import { getAllCustomersByUnitId } from '@/api/modules/unit.js';
import { getUserInfo } from '@/utils/auth.js';

export default {
  name: 'CustomerContractEdit',
  data() {
    return {
      isEdit: false, // 是否是编辑模式
      contractId: null, // 合同ID
      contractForm: {
        contract_name: '',
        contractNumber: '',
        is_interest: '是',
        pricing_method: 'fixed',
        settlement_method: '每月20日结算',
        payment_days: '30',
        payment_days_second: '90',
        interest_condition: '',
        interest_type: '固定利率',
        fixed_interest_rate: '0.00',
        customer_ids: [], // 客户ID列表
        products: [] // 合同商品明细默认为空
      },
      variableRates: [], // 使用数组存储变动利率
      rules: {
        contract_name: [
          { required: true, message: '请输入合同名称', trigger: 'blur' }
        ],
        is_interest: [
          { required: true, message: '请选择是否计息', trigger: 'change' }
        ],
        settlement_method: [
          { required: true, message: '请选择结算方式', trigger: 'change' }
        ],
        payment_days: [
          { required: true, message: '请输入付款天数', trigger: 'blur' }
        ],
        payment_days_second: [
          { required: true, message: '请输入第二次付款天数', trigger: 'blur' }
        ],
        interest_condition: [
          { required: true, message: '请输入计息条件', trigger: 'blur' }
        ],
        pricing_method: [
          { required: true, message: '请选择计价方式', trigger: 'change' }
        ],
        customer_ids: [
          { required: true, message: '请选择至少一个客户', trigger: 'change' }
        ],
        interest_type: [
          { required: true, message: '请选择计息方式', trigger: 'change' }
        ],
        fixed_interest_rate: [
          { required: true, message: '请输入固定利率', trigger: 'blur' }
        ]
      },
      customerOptions: [], // 客户选项列表
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 13
      },
      importDialogVisible: false,
      importFileList: [],
      loading: false
    }
  },
  created() {
    // 根据路由参数判断是新增还是编辑
    this.contractId = this.$route.params.id;
    if (this.contractId) {
      this.isEdit = true;
      this.fetchContractData();
    } else {
      // 默认添加一个空的变动利率
      this.addVariableRate();
      // 新增模式下不初始化默认产品数据
    }
    
    // 调用API获取客户及项目数据
    this.fetchCustomersWithProjects();
  },
  methods: {
    // 获取合同详情数据
    fetchContractData() {
      this.loading = true;
      getContractById(this.contractId)
        .then(response => {
          // 打印完整的响应数据，用于调试
if (response.data && response.data.success) {
            const contractData = response.data.data;
            
            // 打印合同数据的具体结构
// 映射计价方式
            const pricingMethodMap = {
              'FIXED': 'fixed',
              'VARIABLE': 'variable'
            };
            
            // 填充基本合同信息
            this.contractForm = {
              contract_name: contractData.contractName || '',
              contractNumber: contractData.contractNumber || '',
              is_interest: contractData.interestCalculation ? '是' : '否',
              settlement_method: contractData.settlementMethod || '每月20日结算',
              payment_days: contractData.payment70PercentDays?.toString() || '30',
              payment_days_second: contractData.paymentFullDays?.toString() || '90',
              interest_condition: contractData.interestFreeDays?.toString() || '',
              pricing_method: pricingMethodMap[contractData.pricingMethod] || 'fixed',
              customer_ids: [],
              products: []
            };
            
            // 获取固定利率值
            const fixedRateValue = contractData.fixedInterestRate || 0;
// 获取变动利率数据 - 新API可能没有这个字段，保持兼容
            let variableRatesData = contractData.variableInterestRates || [];
// 如果变动利率数据不是数组，尝试解析
            if (variableRatesData && !Array.isArray(variableRatesData) && typeof variableRatesData === 'string') {
              try {
                variableRatesData = JSON.parse(variableRatesData);
} catch (e) {
                console.error('解析变动利率数据失败:', e);
                variableRatesData = [];
              }
            }
            
            // 确保是数组
            if (!Array.isArray(variableRatesData)) {
              console.warn('变动利率数据不是数组，已重置为空数组');
              variableRatesData = [];
            }
            
            // 根据interestRateType判断利率类型
            if (contractData.interestRateType === 'FIXED') {
              this.contractForm.interest_type = '固定利率';
              this.contractForm.fixed_interest_rate = fixedRateValue?.toString() || '0.00';
// 清空变动利率
              this.variableRates = [];
              this.addVariableRate(); // 添加一个空的变动利率表单项，方便用户切换
            } else {
              // 变动利率类型
              this.contractForm.interest_type = '变动利率';
              this.contractForm.fixed_interest_rate = '0.00';
              
              // 设置变动利率
              if (variableRatesData && variableRatesData.length > 0) {
                this.variableRates = variableRatesData.map(item => {
// 解析天数值
                  let daysValue = '';
                  if (item.days !== undefined) {
                    daysValue = item.days.toString();
                  } else if (item.date_max !== undefined) {
                    daysValue = item.date_max.toString();
                  }
                  
                  // 解析利率值
                  let rateValue = '0';
                  if (item.rate) {
                    // 直接使用原始利率值，不做转换
                    const rateNum = parseFloat(item.rate);
                    if (!isNaN(rateNum)) {
                      rateValue = rateNum.toString();
                    }
                  }
                  
return {
                    id: item.id,
                    days: daysValue,
                    rate: rateValue
                  };
                });
} else {
                // 没有变动利率记录，添加一个空的
                this.variableRates = [];
                this.addVariableRate();
              }
            }
            
            // 处理材料清单 - 使用新API的contractItems字段
            if (contractData.contractItems && contractData.contractItems.length > 0) {
              this.contractForm.products = contractData.contractItems.map(item => ({
                id: item.id,
                category: item.remark || '', // 使用remark作为分类
                seq_no: item.id ? item.id.toString() : '',
                material_name: item.productName || '', // 使用productName
                spec_model: item.specification || '',
                unit: item.unit || '',
                quantity: parseFloat(item.quantity) || 0,
                unit_price: parseFloat(item.unitPrice) || 0,
                tax_rate: item.taxRate ? parseFloat(item.taxRate) : 0, // 使用taxRate字段，确保不为null
                tax_price: parseFloat(item.totalAmount) || 0, // 使用totalAmount
                supplier_name: '' // 移除供应商名称，因为这是客户合同
              }));
}
            
            // 处理客户信息 - 使用新API的contractParties字段
            if (contractData.contractParties && contractData.contractParties.length > 0) {
// 提取所有相关的客户ID
              const customerIds = [];
              
              // 处理客户方信息 - 从contractParties中提取客户
              contractData.contractParties.forEach(party => {
                if (party.partyType === 'CUSTOMER') {
                  const customerId = party.unitInfo?.id || party.unitInfoId;
                  
                  if (customerId && !customerIds.includes(customerId)) {
                    customerIds.push(customerId);
}
                }
              });
              
              // 设置客户ID列表
              this.contractForm.customer_ids = customerIds;
}
            
            // 确保客户数据已加载
            this.$nextTick(() => {
              // 如果客户选项为空，先获取客户数据 
              if (this.customerOptions.length === 0) {
                this.fetchCustomersWithProjects();
              }
            });
          } else {
            this.$message.error(response.data?.message || '获取合同详情失败');
          }
        this.loading = false;
        })
        .catch(error => {
          console.error('获取合同详情失败:', error);
          // 打印详细的错误信息
          
          this.$message.error('获取合同详情失败: ' + (error.response?.data?.message || error.message || '未知错误'));
          this.loading = false;
        });
    },
    
    // 获取客户列表
    fetchCustomersWithProjects() {
      this.loading = true;
      
      // 获取当前用户信息
      const currentUser = getUserInfo();
// 获取用户单位ID
      let currentUnitId = null;
      
      // 按照项目中其他组件的方式获取用户单位ID
      if (currentUser && currentUser.unit_id) {
        currentUnitId = currentUser.unit_id;
} else if (currentUser && currentUser.unitId) {
        currentUnitId = currentUser.unitId;
} else {
        console.warn('无法获取有效的用户单位ID');
        currentUnitId = 1; // 默认值，应该根据实际情况调整
}
      
      // 使用新的API获取客户列表
      getAllCustomersByUnitId(currentUnitId)
        .then(response => {
          // 打印客户数据
try {
            if (response.data && response.data.success) {
              // 数据在 data 中
              const customersData = response.data.data || [];
              
              // 确保 customersData 是数组
              if (!Array.isArray(customersData)) {
                console.warn('客户数据不是数组格式');
                this.customerOptions = [];
                return;
              }
              
              if (!customersData.length) {
                console.warn('未获取到客户数据或数据为空');
              }
              
              // 处理API返回的客户列表
              this.customerOptions = customersData.map(item => {
                return {
                  id: item.id,
                  unit_name: item.unitName, // 使用新API的字段名
                  contactPerson: item.contactPerson,
                  phone: item.phone,
                  taxId: item.taxId,
                  address: item.address,
                  bankName: item.bankName,
                  bankAccount: item.bankAccount,
                  status: item.status
                };
              });
              
// 如果是编辑模式并且合同数据已加载，同步客户选择
              if (this.isEdit && this.contractForm.customer_ids.length > 0) {
// 确保选择正确同步到UI
                this.$nextTick(() => {
                  // 客户选择已经通过customer_ids处理，不需要额外处理
                });
              } else if (this.isEdit) {
                // 如果是编辑模式但客户列表为空，可能是合同数据已加载但客户未正确设置
this.fetchContractData();
              }
            } else {
              this.$message.error(response.data?.message || '获取客户数据失败');
              console.error('获取客户数据失败:', response.data);
            }
          } catch (err) {
            console.error('处理客户数据时发生错误:', err);
            this.$message.error('处理客户数据时发生错误');
          } finally {
            this.loading = false;
          }
        })
        .catch(error => {
          console.error('获取客户数据错误:', error);
          this.$message.error('获取客户数据失败: ' + (error.response?.data?.message || error.message || '未知错误'));
          this.loading = false;
        });
    },
    
    // 新增变动利率
    addVariableRate() {
      this.variableRates.push({
        days: '',
        rate: ''
      });
    },
    
    // 删除变动利率
    removeVariableRate(index) {
      this.variableRates.splice(index, 1);
      
      // 确保至少有一个变动利率记录
      if (this.variableRates.length === 0) {
        this.addVariableRate();
      }
    },
    
    // 生成模拟商品数据
    generateMockProducts() {
      const products = [];
      for (let i = 1; i <= 13; i++) {
        products.push({
          category: '化工',
          seq_no: i.toString(),
          material_name: '水性油漆',
          spec_model: '品牌：不限，颜色：综合',
          unit: 'KG',
          quantity: 100,
          unit_price: 5.8,
          tax_rate: 13,
          tax_price: this.calculateTaxIncludedPrice({price: 5.8, tax_rate: 13}),
          supplier_name: '四川华西亮九建筑工程有限公司'
        });
      }
      return products;
    },
    
    // 添加商品明细
    addProduct() {
      const newIndex = this.contractForm.products.length + 1;
      this.contractForm.products.push({
        category: '化工',
        seq_no: newIndex.toString(),
        material_name: '',
        spec_model: '',
        unit: 'KG',
        quantity: 0,
        unit_price: 0,
        tax_rate: 13,
        tax_price: 0,
        supplier_name: ''
      });
    },
    
    // 删除商品明细
    removeProduct(index) {
      this.$confirm('确定要删除该行记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      this.contractForm.products.splice(index, 1);
        this.$message.success('删除成功');
      }).catch(() => {
        // 用户取消删除操作
      });
    },
    
    // 计算含税价格
    calculateTaxIncludedPrice({ price, tax_rate }) {
      if (!price || !tax_rate) return price;
      
      // 转换为数字
      price = parseFloat(price);
      const taxRate = parseFloat(tax_rate) || 0;
      
      // 直接使用税率计算，假设税率已经是百分比形式（如13表示13%）
      const taxIncludedPrice = price * (1 + taxRate / 100);
      return taxIncludedPrice.toFixed(2);
    },
    
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          const isEdit = !!this.contractId;
          
          // 准备提交数据，使用新的统一API结构
          const submitData = {
            // 仅在编辑模式下包含id字段
            ...(isEdit ? { id: parseInt(this.contractId) } : {}),
            contractName: this.contractForm.contract_name,
            contractNumber: this.contractForm.contractNumber,
            contractType: 'SALES', // 销售合同类型
            contractDate: new Date().toISOString(), // 当前时间作为合同日期
            pricingMethod: this.contractForm.pricing_method === 'fixed' ? 'FIXED' : 'VARIABLE',
            interestCalculation: this.contractForm.is_interest === '是',
            settlementMethod: this.contractForm.settlement_method,
            payment70PercentDays: parseInt(this.contractForm.payment_days) || 30,
            paymentFullDays: parseInt(this.contractForm.payment_days_second) || 90,
            interestFreeDays: parseInt(this.contractForm.interest_condition) || 15,
            interestRateType: this.contractForm.interest_type === '固定利率' ? 'FIXED' : 'VARIABLE',
            fixedInterestRate: this.contractForm.interest_type === '固定利率' 
              ? parseFloat(this.contractForm.fixed_interest_rate || '0.00')
              : 0,
            variableInterestRates: this.contractForm.interest_type === '变动利率' 
              ? this.variableRates.map(rate => ({
                  id: rate.id ? parseInt(rate.id) : undefined,
                  days: parseInt(rate.days) || 0,
                  rate: parseFloat(rate.rate) || 0
                })) 
              : [],
            // 合同参与方 - 客户
            contractParties: this.contractForm.customer_ids.map(customerId => ({
              ...(isEdit ? {} : {}), // 编辑时可能需要包含现有的party ID
              unitInfoId: parseInt(customerId),
              partyType: 'CUSTOMER',
              isPrimary: true,
              remark: '主要客户'
            })),
            // 合同明细项目
            contractItems: this.contractForm.products.map(item => ({
              ...(isEdit && item.id ? { id: item.id } : {}), // 编辑时包含现有item ID
              productName: item.material_name || '',
              specification: item.spec_model || '',
              unit: item.unit || '',
              quantity: parseFloat(item.quantity) || 0,
              unitPrice: parseFloat(item.unit_price) || 0,
              totalAmount: parseFloat(item.tax_price) || (parseFloat(item.quantity) * parseFloat(item.unit_price)),
              taxRate: parseFloat(item.tax_rate) || 0, // 添加taxRate字段
              remark: item.category || ''
            }))
          };
          
          // 计算合同总金额
          submitData.contractAmount = submitData.contractItems.reduce((sum, item) => {
            return sum + (item.totalAmount || 0);
          }, 0);
          
          // 确保选中了至少一个客户
          if (submitData.contractParties.length === 0) {
            this.$message.error('请至少选择一个客户');
            this.loading = false;
            return;
          }
          
          this.$message.success(`正在${isEdit ? '更新' : '创建'}合同数据...`);
// 使用新的统一合同API
          saveContract(submitData)
            .then(response => {
if (response.data && response.data.success) {
                this.$message.success(`${isEdit ? '更新' : '创建'}合同成功`);
                // 保存成功后返回
                setTimeout(() => {
                  this.goBack();
                }, 500);
              } else {
                this.$message.error(response.data.message || `${isEdit ? '更新' : '创建'}合同失败`);
              }
              this.loading = false;
            })
            .catch(error => {
              console.error(`${isEdit ? '更新' : '创建'}合同失败:`, error);
              this.$message.error(`${isEdit ? '更新' : '创建'}合同失败: ` + (error.response?.data?.message || error.message || '未知错误'));
              this.loading = false;
            });
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });
    },
    
    // 映射计价方式
    mapPricingMethod(method) {
      const methodMap = {
        'fixed': '固定价',
        'float': '变动价'
      };
      return methodMap[method] || '固定价';
    },
    
    // 处理利率类型变更
    
    
    handleInterestTypeChange() {
        this.$forceUpdate();
      },
      
      // 预览合同
      previewContract() {
      // 判断是否有合同ID
      const contractId = this.contractId || 'new';
      
      // 直接跳转到客户合同预览页面
      this.$router.push({
        path: `/contracts/customer/view/${contractId}`
      }).catch(err => {
        console.error('预览页面跳转失败:', err);
        this.$message.error('跳转到预览页面失败');
      });
    },
    
    // 返回上一页
    goBack() {
      this.$router.push('/contracts/customer-contracts-list');
    },
    
    // Excel文件上传前的验证
    beforeExcelUpload(file) {
      const isExcel = 
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
        file.type === 'application/vnd.ms-excel' ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls');
        
      if (!isExcel) {
        this.$message.error('只能上传Excel文件!');
        return false;
      }
      
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('文件大小不能超过5MB!');
        return false;
      }
      
      return true;
    },
    
    // 处理Excel文件上传
    handleExcelUpload({ file }) {
      const loading = this.$loading({
        lock: true,
        text: '正在解析Excel文件...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      // 使用FileReader读取文件
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          // 获取第一个工作表
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          
          // 将工作表转换为JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          // 处理数据 - 跳过标题行
          if (jsonData && jsonData.length > 1) {
            // const headers = jsonData[0]; // 第一行是标题（暂未使用）
            const products = [];
            
            // 从第二行开始处理数据
            for (let i = 1; i < jsonData.length; i++) {
              const row = jsonData[i];
              if (row.length > 0 && row[0]) { // 确保行不为空
                const product = {
                  category: row[0] || '',
                  seq_no: i.toString(),
                  material_name: row[1] || '',
                  spec_model: row[2] || '',
                  unit: row[3] || '',
                  quantity: row[4] || '',
                  unit_price: row[5] || '',
                  tax_rate: row[6] != null && row[6] !== '' ? row[6] : 0, // 保持原始格式，避免转换问题
                  tax_price: row[7] || '',
                  supplier_name: row[8] || ''
                };
                products.push(product);
              }
            }
            
            this.contractForm.products = products;
            this.$message.success(`成功导入 ${products.length} 条记录`);
          } else {
            this.$message.warning('导入的Excel文件没有有效数据');
          }
          
          loading.close();
        } catch (error) {
          console.error('解析Excel文件失败:', error);
          this.$message.error('解析Excel文件失败，请检查文件格式');
          loading.close();
        }
      };
      
      reader.onerror = () => {
        this.$message.error('读取文件失败');
        loading.close();
      };
      
      reader.readAsArrayBuffer(file);
    },
    
    // 上传前校验导入文件
    beforeImportUpload(file) {
      const isExcel = file.type === 'application/vnd.ms-excel' || 
                      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const isLt10M = file.size / 1024 / 1024 < 10;
      
      if (!isExcel) {
        this.$message.error('只能上传Excel文件!');
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!');
      }
      
      return isExcel && isLt10M;
    },
    
    // 处理文件上传
    handleImportUpload(options) {
      const { file } = options;
      this.importFileList = [{ name: file.name, size: file.size }];
      options.onSuccess();
    },
    
    // 确认导入
    confirmImport() {
      if (this.importFileList.length === 0) {
        this.$message.warning('请先上传Excel文件');
        return;
      }
      
      this.loading = true;
      setTimeout(() => {
        // 模拟导入成功
        this.$message.success('导入成功，共导入13条数据');
        this.importDialogVisible = false;
        this.loading = false;
        
        // 模拟导入的数据
        this.contractForm.products = this.generateMockProducts();
      }, 1000);
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
    },
    
    // 页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    
    // 反向映射计价方式
    reversePricingMethod(method) {
      const methodMap = {
        '固定价': 'fixed',
        '变动价': 'float'
      };
      return methodMap[method] || 'fixed';
    },
    
    // 转换是否计息的值为radio可识别的格式
    convertIsMeasured(value) {
// 处理undefined或null的情况
      if (value === undefined || value === null) {
return '是';
      }
      
      // 处理字符串类型
      if (typeof value === 'string') {
        if (['1', '是', 'true', 'True', 'TRUE', 'yes', 'Yes', 'YES'].includes(value)) {
return '是';
        }
        if (['0', '否', 'false', 'False', 'FALSE', 'no', 'No', 'NO'].includes(value)) {
return '否';
        }
      }
      
      // 处理数字类型
      if (typeof value === 'number') {
        if (value === 1) {
return '是';
        }
        if (value === 0) {
return '否';
        }
      }
      
      // 处理布尔类型
      if (typeof value === 'boolean') {
        if (value === true) {
return '是';
        }
        if (value === false) {
return '否';
        }
      }
      
      // 默认返回"是"
return '是';
    },
    
    // 处理客户选择变更
    handleCustomerChange(selectedItems) {
// 更新客户IDs (用于表单验证和提交)
      if (selectedItems && selectedItems.length > 0) {
        // 客户ID已经直接存储在数组中，不需要额外处理
        this.contractForm.customer_ids = selectedItems;
      } else {
        // 如果没有选择项，则清空
        this.contractForm.customer_ids = [];
      }
      
},
    // 格式化税率显示（添加%符号）
    formatTaxRate(value) {
      if (value === null || value === undefined || value === '') return '0%';
      const num = parseFloat(value);
      if (isNaN(num)) return '0%';
      // 如果值小于1，说明是小数形式（如0.13），转换为百分比形式（13）
      if (num < 1 && num > 0) {
        return `${Math.round(num * 100)}%`;
      }
      // 如果值大于等于1，说明已经是百分比形式（如13），直接返回
      return `${Math.round(num)}%`;
    },
    
    // 格式化单价（保留8位小数，去除末尾无意义的0）
    formatUnitPrice(amount) {
      if (!amount && amount !== 0) return '0';
      const num = parseFloat(amount);
      if (isNaN(num)) return '0';
      // 先格式化为8位小数，然后去除末尾的0
      const formatted = num.toFixed(8);
      // 去除末尾的0和小数点（如果有）
      return formatted.replace(/\.?0+$/, '') || '0';
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-contract-edit-container {
  padding: 20px;
  background-color: #f0f2f5;
}
  
  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
    
    .blue-bar {
  width: 4px;
  height: 20px;
  background-color: #409EFF;
      margin-right: 8px;
    }
    
    .page-title {
  font-size: 18px;
  font-weight: bold;
      margin: 0;
  color: #333;
  }
  
  .contract-form {
  background-color: transparent;
}

.form-section {
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
      margin-bottom: 20px;
  border: 1px solid #ebeef5;
}
      
.form-row {
        display: flex;
  margin-bottom: 20px;
}

.form-item {
  flex: 1;
  margin-right: 20px;
  position: relative;
}

.form-item:last-child {
  margin-right: 0;
        }

.form-item.wide {
  flex: 3;
}

.form-item.smaller {
  flex: 0.6;
    }
    
    .required-label {
  display: block;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  margin-bottom: 8px;
}

.required-label::before {
        content: '*';
  color: #F56C6C;
        margin-right: 4px;
    }
    
.radio-group {
      display: flex;
  height: 40px;
      align-items: center;
}

.radio-option {
  margin-right: 20px;
}

.radio-option.large {
  margin-right: 30px;
      }
      
.bordered-option {
  min-width: 80px;
  padding: 0 15px;
  height: 34px;
  line-height: 34px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
        margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bordered-option:hover {
  border-color: #409EFF;
}

::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #409EFF;
}

::v-deep .bordered-option .el-radio {
  margin-right: 0;
}

.payment-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.payment-input-group {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 10px;
}

.payment-prefix {
  width: 30px;
  text-align: right;
  color: #606266;
  margin-right: 15px;
}

.payment-second-row {
  margin-left: 0;
}

.label-text {
  margin: 0 10px;
  color: #606266;
  white-space: nowrap;
  display: inline-block;
  width: 20px;
  text-align: center;
}

.payment-text {
  margin-left: 10px;
  color: #606266;
}

.day-input {
  width: 150px !important;
    }
    
    .customer-tree {
  margin-top: 15px;
}

.table-section {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
      border-radius: 4px;
  border: 1px solid #ebeef5;
    }
    
.table-header {
    display: flex;
  margin-bottom: 15px;
}

.excel-uploader {
  display: inline-block;
  margin-right: 10px;
}

.import-btn {
  margin-bottom: 15px;
  background-color: #17B3A3;
  border-color: #17B3A3;
}

.pagination {
  margin-top: 15px;
  text-align: right;
  }
  
  .form-actions {
  display: flex;
  justify-content: center;
    margin-top: 30px;
  margin-bottom: 50px;
}
    
.form-actions .el-button {
      margin: 0 10px;
  min-width: 100px;
}

/* 覆盖Element UI的部分样式 */
::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 2px;
}

::v-deep .el-radio__inner {
  border-color: #DCDFE6;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #409EFF;
  background: #409EFF;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-table th {
  background-color: #f5f7fa;
}

::v-deep .el-table--border {
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409EFF;
}

.payment-option {
  min-width: 180px;
  height: 36px;
  margin-right: 15px;
}

/* 利率相关样式 */
.interest-rate-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.interest-rate-group {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 10px;
}

.rate-radio-container {
  width: 90px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.rate-inputs-container {
  display: flex;
  align-items: center;
}

.rate-inputs-container .day-input,
.rate-inputs-container .rate-input {
  margin-right: 0;
}

.rate-radio {
  width: auto;
}

.variable-rate-row {
  display: flex;
  margin-bottom: 10px;
}

.variable-rate-row .rate-radio-container {
  visibility: hidden;
}

.rate-input {
  width: 150px !important;
}

.rate-input.percent {
  width: 150px !important;
}

.add-btn {
  background-color: #409EFF;
  border-color: #409EFF;
  margin-left: 10px;
}

.delete-btn {
  color: #F56C6C !important;
  margin-left: 10px;
  min-width: 60px !important;
}

.customer-option {
  font-weight: bold;
  color: #303133;
}

.customer-info {
  font-weight: normal;
  color: #909399;
  font-size: 12px;
  margin-left: 5px;
}

/* 调整select显示选中项的方式 */
::v-deep .el-select__tags {
  flex-wrap: wrap;
  padding-right: 30px;
  padding-left: 15px;
}

::v-deep .el-select__tags-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px; /* 限制单个标签的最大宽度 */
}

::v-deep .el-tag {
  margin: 2px 4px 2px 0;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
}

/* 调整客户选择框的样式 */
.customer-select {
  width: 100%;
}

.customer-select ::v-deep .el-select__tags {
  max-width: calc(100% - 30px);
}

::v-deep .el-tag--info {
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
}

::v-deep .el-select .el-tag__close {
  background-color: transparent;
  color: #909399;
  transform: scale(0.8);
}

::v-deep .el-select .el-tag__close:hover {
  background-color: #909399;
  color: #fff;
}

.variable-rate-delete-btn {
  color: #FFFFFF !important;
  background-color: #F56C6C !important;
  border-color: #F56C6C !important;
  margin-left: 10px;
  min-width: 60px !important;
}

.variable-rate-delete-btn:hover {
  background-color: #ff7875 !important;
  border-color: #ff7875 !important;
}

::v-deep .el-select .el-tag__close:hover {
  background-color: #909399;
  color: #fff;
}

::v-deep .el-select__input {
  margin-left: 2px;
}

::v-deep .el-select-dropdown__item.selected {
  color: #606266;
  font-weight: normal;
}

.customer-option {
  font-weight: bold;
  color: #303133;
}

/* 变动利率删除按钮样式 */
</style>